module.exports = __webpack_public_path__ + "img/fb.90ebaee5.png";